export default "__VITE_ASSET__CSI5KLj$__"